import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';

export const SectionHeader = styled.div`
    border-bottom: 1px solid ${RacemapColors.PaleBlue};
    font-weight: bold;
`;
